import { Mixpanel } from 'mixpanel-browser'
import { createContext, FC, useContext } from 'react'
import { useAuth } from '..'
import { logFactory as nativeLogFactory } from '../../util'
import { init } from '../services/mixpanel'

interface MixpanelContext {
  logFactory: (message: string) => void
  mixpanel: Mixpanel | undefined
}

const logNamespace = 'mixpanel'
const logFactory = (method: string) => nativeLogFactory(logNamespace, method)

const defaultContext = {
  logFactory,
  mixpanel: undefined,
}

const context = createContext<MixpanelContext>(defaultContext)
const { Provider } = context
const MixpanelProvider: FC = ({ children }) => {
  const { user } = useAuth()
  const value: MixpanelContext = {
    logFactory,
    mixpanel: user ? init(user.account_id) : undefined,
  }

  return <Provider value={value}>{children}</Provider>
}
const useMixpanel = (): MixpanelContext => useContext(context)

export { MixpanelProvider, useMixpanel }
